module.exports = __webpack_public_path__ + "static/media/Advanced.e67a5ed0.svg";